export default __webpack_public_path__ + "static/mahima-ff86429631ab1899727b92592d0b5a87.png";